import i18n from 'services/i18n';
import { PASSWORD_LENGHT_MIN, PASSWORD_REGEX } from 'constants/forms';
import { test } from 'ramda';

export default function validate({ currentPassword, newPassword, confirmNewPassword }) {
  const errors = {};

  if (!currentPassword) {
    errors.currentPassword = i18n.t('validation:fieldRequired');
  }

  if (!newPassword) {
    errors.newPassword = i18n.t('validation:fieldRequired');
  }

  if (!confirmNewPassword) {
    errors.confirmNewPassword = i18n.t('validation:fieldRequired');
  }

  if (newPassword && confirmNewPassword) {
    if (!test(PASSWORD_REGEX, newPassword)) {
      errors.newPassword = i18n.t('validation:passwordNotCorrect', {
        minLength: PASSWORD_LENGHT_MIN,
      });
    }

    if (newPassword !== confirmNewPassword) {
      errors.confirmNewPassword = i18n.t('validation:passwordsNotEqual');
    }
  }

  return errors;
}
